"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var money_model_1 = require("../money/money.model");
var AccountingModel = /** @class */ (function () {
    function AccountingModel(rateToDefault, originalMoney, accountingDate) {
        this.rateToDefault = rateToDefault;
        this.originalMoney = originalMoney;
        this.accountingDate = accountingDate;
    }
    return AccountingModel;
}());
exports.AccountingModel = AccountingModel;
function compareAccounting(first, second) {
    if (lodash_1.isNil(first) || lodash_1.isNil(second)) {
        return lodash_1.isNil(first) && lodash_1.isNil(second);
    }
    return (money_model_1.compareMoney(first.originalMoney, second.originalMoney) &&
        first.rateToDefault === second.rateToDefault &&
        first.accountingDate === second.accountingDate);
}
exports.compareAccounting = compareAccounting;
function isEmptyAccounting(accounting) {
    return (lodash_1.isNil(accounting) ||
        (lodash_1.isNil(accounting.accountingDate) &&
            lodash_1.isNil(accounting.rateToDefault) &&
            money_model_1.isMoneyNil(accounting.originalMoney)));
}
exports.isEmptyAccounting = isEmptyAccounting;
//# sourceMappingURL=accounting.model.js.map